import { createAsyncThunk } from '@reduxjs/toolkit'
import { BET_RESULT } from 'utils/constants/index'
import { openSuccessWireToaster } from 'utils/common-services/toaster.service'
import { creditBalance, debitBalance } from 'redux-store/redux/slices/auth.slice'
import {
  cashoutService,
  getBetsHistoryService,
  getTopBetsService,
  getTowerCurrentGameStateService,
  nextLevelService,
  openedTileService,
  placeBetService
} from 'network/services/towerGame.service'

export const getBetsHistoryThunk = createAsyncThunk('tower/fetch-bets', async (data, thunkApi) => {
  try {
    const res = await getBetsHistoryService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const placeBetThunk = createAsyncThunk('tower/place-bet', async (data, thunkApi) => {
  const { payload, setRoundId, onPlaceBetSuccess } = data
  try {
    const res = await placeBetService(payload)
    // openSuccessWireToaster({
    //   message: 'Bet placed successfully'
    // })
    setRoundId(res?.roundId)
    onPlaceBetSuccess()
    // thunkApi.dispatch(debitBalance(res?.betAmount || 0))
    return res
  } catch (error) {
    data.setBetLoader(false)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const openedTileThunk = createAsyncThunk('tower/opened-tile', async (data, thunkApi) => {
  try {
    const res = await openedTileService(data?.payload)

    if (res?.result === BET_RESULT.WON) {
      thunkApi.dispatch(creditBalance(res?.winningAmount || 0))
    }
    return res
  } catch (error) {
    data?.onError()
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cashoutThunk = createAsyncThunk('tower/cashout', async (data, thunkApi) => {
  try {
    const { onSuccess } = data
    const res = await cashoutService()
    onSuccess({ cashoutResponse: res })
    if (res?.result === BET_RESULT.WON) {
      thunkApi.dispatch(creditBalance(res?.winningAmount || 0))
    }
    return res
  } catch (error) {
    data.setBetLoader(false)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getCurrenctGameStateThunk = createAsyncThunk(
  'tower/get-current-game-state',
  async (_, thunkApi) => {
    try {
      const res = await getTowerCurrentGameStateService()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const nextLevelThunk = createAsyncThunk('tower/next-level', async (data, thunkApi) => {
  const { payload, onSuccess } = data
  try {
    const res = await nextLevelService(payload)
    onSuccess(res)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getTopBets = createAsyncThunk('tower-game/topBets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
